<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('my-shops')">My Shops</inertia-link>
            <span class="text-indigo-400 font-medium">/</span> Create
        </h1>

        <div class="">
            <form @submit.prevent="submit">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap bg-white rounded shadow max-w-3xl">
                    <div class="pr-6 pb-8 w-full">
                        <div class="text-sm items-center flex">
                            <toggle v-model="form.none_tax" class="mr-3" />
                            <span v-if="!form.none_tax">Enable, if you're not GST registered</span>
                            <span v-else>Not tax registered</span>
                        </div>
                    </div>
                    <text-input v-show="!form.none_tax" v-model="form.tin_number" :disabled="form.none_tax" :errors="$page.props.errors.tin_number" class="pr-6 pb-8 w-full lg:w-1/2" label="GST TIN Number" />
                    <text-input v-model="form.name" :errors="$page.props.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Shop/Business Name" />
                </div>

                <div class="p-8 -mr-6 -mb-8 flex flex-wrap bg-white rounded shadow max-w-3xl">

                    <select-input v-model="form.business_type" class="pr-6 pb-8 w-full lg:w-1/2" label="Business Type">
                        <option :value="null" />
                        <option v-for="(btype, bkey) in business_types" :value="bkey" :key="bkey">{{ btype }}</option>
                    </select-input>


                    <select-input v-model="form.atoll_id" :errors="$page.props.errors['atoll_id']" class="pr-6 pb-8 w-full lg:w-1/2" label="Atoll">
                        <option :value="null" />
                        <option v-for="(atoll, aindx) in atoll_list" :value="atoll.id" :key="aindx">{{ atoll.name }}</option>
                    </select-input>
                    <select-input v-if="form.atoll_id" v-model="form.island_id" :errors="$page.props.errors.island_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Island" >
                        <option :value="null" />
                        <option v-if="form.atoll_id && form.atoll_id === irow.atoll_id" v-for="irow in island_list" :value="irow.id" :key="irow.id">{{ irow.name }}</option>
                    </select-input>

                </div>

                <div class="bg-gray-100 py-4 px-8 -mr-6 -mb-4 flex flex-wrap bg-white rounded shadow max-w-3xl">
                    <loading-button :loading="sending" class="btn-primary" type="submit">Submit</loading-button>
                </div>


            </form>
        </div>
    </div>
</template>

<script>
  import Layout from '@/Shared/Customers/Layout'
  import LoadingButton from '@/Shared/LoadingButton'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'
  import Toggle from '@/Shared/Toggle'

  export default {
    metaInfo: { title: 'Create Shop/Business' },
    layout: Layout,
    components: {
      LoadingButton,
      SelectInput,
      TextInput,
      Toggle
    },
    remember: 'form',
    props: {
      business_types: Object,
      locations: Object,
      atoll_list: Array,
      island_list: Array,
    },

    data() {
      return {
        sending: false,
        form: {
          name: null,
          none_tax: false,
          tin_number: null,
          location: null,
          island_id: null,
          atoll_id: null,
          business_type: null
        },
      }
    },

    watch: {
      'form.none_tax': function(val) {
        if(val) {
          this.form.tin_number = null;
        }
      },
      'form.atoll_id' : function() {
        this.form.island_id = null
      }
    },
    methods: {
      submit() {
        this.sending = true
        this.$inertia.post(this.route('my-shops.store'), this.form)
          .then(() => this.sending = false)
      }
    },
  }
</script>
